import { useNavigate } from "@solidjs/router";
import { createSignal } from "solid-js";
import RegisterForm from "../components/forms/RegisterForm";

export default function Signup() {
  return (
    <div class="page">
      <div class="logo-container">
        <h1>mia</h1>
      </div>
      <RegisterForm></RegisterForm>
    </div>
  );
}
